<template lang="pug">
  span.qmod-toggle-wrap(:class='enabled ? "qmod-toggle-on" : "qmod-toggle-off"')
    span.qmod-toggle-text.qmod-toggle-text-left {{getEnabled}}
    span.qmod-toggle-toggle

</template>

<script>
export default {
  name: "ToggleButton",
  props: ["enabled"],
  data() {
    return {}
  },
  methods: {},
  computed: {
    getEnabled() {
      return this.enabled ? "On" : "Off"
    }
  },
  mounted() {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
$qmblue = #0a64a6
.qmod-toggle-wrap
  cursor pointer
  border 1px solid #ccc
  border-radius 25px
  position relative
  min-width 60px
  transition border 0.4s ease 0s, box-shadow 0.4s ease 0s, background-color 1.2s ease 0s
  &.qmod-toggle-on
    color #fff
    box-shadow rgb(100, 189, 99) 0px 0px 0px 11px inset
    .qmod-toggle-toggle
      right 0
      border none
      left auto
      top 0
    .qmod-toggle-text
      padding-left 12px
  .qmod-toggle-toggle
    left 0
    top -1px
    display inline-block
    min-height 100%
    min-width 20px
    background-color #fff
    border-radius 25px
    position absolute
    border 1px solid #ccc
  .qmod-toggle-text
    padding-left 26px
    // font-size px
</style>
